import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Shield, Brain, Lock, Award, LucideIcon } from 'lucide-react';

export type CardData = {
    id: number;
    title: string;
    description: string;
    color: string;
    icon: LucideIcon;
};

export const cardData: CardData[] = [
    {
        id: 1,
        title: "Personalized Assessment",
        description: "AI-driven survey adapts to your role - parent, student, institution, or business - for tailored cybersecurity insights.",
        color: "rgba(255, 193, 7, 0.85)",
        icon: Shield,
    },
    {
        id: 2,
        title: "Smart Analysis",
        description: "Advanced AI evaluates your responses to identify potential security risks and areas for improvement.",
        color: "rgba(251, 191, 36, 0.85)",
        icon: Brain,
    },
    {
        id: 3,
        title: "Security Recommendations",
        description: "Receive customized security tips and actionable steps to enhance your digital protection.",
        color: "rgba(255, 193, 7, 0.85)",
        icon: Lock,
    },
    {
        id: 4,
        title: "Digital Certificate",
        description: "Earn a Smile Cyber Tech Survey Certification recognizing your commitment to online safety.",
        color: "rgba(251, 191, 36, 0.85)",
        icon: Award,
    }
];

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
